import OInputField from 'components/reusable/OInputField'
import useToastContext from 'hooks/useToastContext'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { apiPut } from 'utils/apiFetch'
import apiPath from 'utils/apiPath'
import formValidation from 'utils/formValidation'

const AcceptPropertyModal = ({
  setIsAcceptProperty,
  item,
  getApprovedProperties
}) => {
  const { t } = useTranslation()
  const notification = useToastContext()
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    mode: 'onChange',
    shouldFocusError: true,
    defaultValues: {
      trakheesiPermitNumber: item?.permitNumber
    }
  })
  const onSubmit = async data => {
    try {
      const payload = {
        ...data,
        isApprovedStatus: 'accepted'
      }
      const path = `${apiPath.approvalPropertyStatusChange}/${item?._id}`
      const result = await apiPut(path, payload)
      const resultResponse = result?.data
      if (resultResponse?.success) {
        notification.success(resultResponse.message)
        getApprovedProperties()
        setIsAcceptProperty(false)
      } else {
        notification.error(resultResponse.message)
      }
    } catch (error) {
      console.error('error in get all users list==>>>>', error.message)
    }
  }
  return (
    <>
      <div className='justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none'>
        <div className='relative w-auto my-6 mx-auto max-w-3xl'>
          <div className='sm:py-4 sm:px-2 py-8 px-7'>
            <div className='border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none min-w-[762px]'>
              <div className='flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t'>
                <h3 className='text-xl font-semibold'>
                  {t('ACCEPT_PROPERTY')}
                </h3>
                <button
                  className=' ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none'
                  onClick={() => setIsAcceptProperty(false)}
                >
                  <span className=' text-[#B8BBBF]  text-4xl ' title='Close'>
                    ×
                  </span>
                </button>
              </div>
              <div className='relative  flex-auto'>
                <div className='p-5'>
                  <div className='grid grid-rows-1 grid-cols-2 gap-4'>
                    <div className='mb-3'>
                      <label className='block'>
                        <OInputField
                          wrapperClassName='relative z-0   w-full group'
                          name='trakheesiPermitNumber'
                          inputLabel={
                            <>
                              {t('TRAKHEESI_PERMIT_NUMBER')}
                              <span className='text-red-500'>*</span>
                            </>
                          }
                          type='text'
                          register={register(
                            'trakheesiPermitNumber',
                            formValidation.trakheesiPermitNumber
                          )}
                          errors={errors}
                        />
                      </label>
                    </div>
                    <div className='mb-3'>
                      <label className='block'>
                        <OInputField
                          wrapperClassName='relative z-0   w-full group'
                          name='referenceNumber'
                          inputLabel={
                            <>
                              {t('REFERENCE_NUMBER')}
                              <span className='text-red-500'>*</span>
                            </>
                          }
                          type='text'
                          register={register(
                            'referenceNumber',
                            formValidation.referenceNumber
                          )}
                          errors={errors}
                        />
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className='flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b'>
                <button
                  className='bg-[#8FC150] text-white active:bg-emerald-600 font-normal text-sm  px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-5  ease-linear transition-all duration-150'
                  onClick={handleSubmit(onSubmit)}
                >
                  {t('O_SUBMIT')}
                </button>
                <button
                  className='text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150'
                  type='button'
                  onClick={() => setIsAcceptProperty(false)}
                >
                  {t('O_CLOSE')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='opacity-25 fixed inset-0 z-40 bg-black' />
    </>
  )
}

export default AcceptPropertyModal
